import { configureStore } from '@reduxjs/toolkit'
import agentsReducer from './slices/agentsSlice'
import failuresReducer from './slices/failuresSlice'
import runsReducer from './slices/runsSlice'
import runDetailsReducer from './slices/runDetailsSlice'
import containersReducer from './slices/containersSlice'
import reportsReducer from './slices/reportsSlice'

export const store = configureStore({
  reducer: {
    agents: agentsReducer,
    failures: failuresReducer,
    runs: runsReducer,
    runDetails: runDetailsReducer,
    containers: containersReducer,
    reports: reportsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
